/* Бутон, който води до блока за поръчка.

   Ако блокът е на същата страница — скролва до него плавно.
   Ако не е — линкът си работи както е зададен и води към продукта.

   Ориентирът се търси измежду няколко възможности, защото ID-тата на
   избора за размер зависят от шаблона и се менят при всяка промяна. */
(function () {
  'use strict';

  var SELECTORS = [
    '#lp-size',
    '.lp-size',
    '.quantity-breaks',
    'variant-selects',
    '.product-form__input',
    '.product-form__submit',
    'button[name="add"]'
  ];

  function findTarget() {
    for (var i = 0; i < SELECTORS.length; i++) {
      var el = document.querySelector(SELECTORS[i]);
      // Празна обвивка не става за ориентир — Shrine държи формата с нулева височина.
      if (el && el.offsetHeight > 0) return el;
    }
    return null;
  }

  function bind(el) {
    if (el.dataset.lpScrollOn === '1') return;
    el.dataset.lpScrollOn = '1';

    el.addEventListener('click', function (e) {
      var goal = findTarget();
      if (!goal) return;            // няма къде да скролнем — следвай линка

      e.preventDefault();
      goal.scrollIntoView({ behavior: 'smooth', block: 'center' });

      // Подсказваме къде е, за да не се чуди човек какво стана.
      goal.classList.add('lp-flash');
      setTimeout(function () { goal.classList.remove('lp-flash'); }, 1200);
    });
  }

  function initAll(root) {
    var nodes = (root || document).querySelectorAll('[data-lp-scroll-buy]');
    Array.prototype.forEach.call(nodes, bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
